document.addEventListener('DOMContentLoaded', function () {
  observeProductChanges();
});

function observeProductChanges() {
  var productsContainer = document.getElementById('bc-sf-filter-products');
  if (!productsContainer) {
    return;
  }

  // Observer configuration
  var config = {
    childList: true, // Observe direct child elements added or removed
    subtree: false, // Do not observe changes in descendant elements
    attributes: false, // Do not observe attribute changes
    characterData: false, // Do not observe text changes
  };

  var observer = new MutationObserver(function (mutations) {
    var relevantMutations = mutations.filter(function (mutation) {
      return mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0;
    });

    if (relevantMutations.length > 0) {
      debouncedInsertContentBlock();
    }
  });

  // Start observing
  observer.observe(productsContainer, config);

  function insertContentBlock() {
    // Disconnect the observer to prevent it from observing the changes made by this function
    observer.disconnect();

    // Select all product items
    var productItems = productsContainer.querySelectorAll('.bc-sf-filter-product-item');
    // Check if there are at least two products
    if (productItems.length >= 2) {
      var existingContentBlock = document.getElementById('inserted-content-block');
      if (existingContentBlock) {
        existingContentBlock.parentNode.removeChild(existingContentBlock);
      }

      // Create the content block element
      var contentBlock = document.createElement('a');
      contentBlock.id = 'inserted-content-block'; // Assign an ID to prevent duplicates
      contentBlock.classList.add('content-block'); // Add the 'test' class to the content block
      contentBlock.href = window.collectionMetafields.contentBlockUrl || '#';

      // Retrieve metafields from the window object
      var title = window.collectionMetafields.contentBlockTitle || '';
      var text = window.collectionMetafields.contentBlockText || '';
      var textColor = window.collectionMetafields.contentBlockTextColor || '#ffffff';
      var image = window.collectionMetafields.contentBlockImage || '';
      var buttonText = window.collectionMetafields.contentBlockButtonText || '';
      var contentBlockColumns = window.collectionMetafields.contentBlockColumns || 2;
      var contentBlockRowSpan = window.collectionMetafields.contentBlockRowSpan || 1;
      var contentBlockPosition = window.collectionMetafields.contentBlockPosition || 3;

      // Adjust content block column span based on contentBlockColumns
      if (contentBlockColumns == '3') {
        contentBlock.classList.add('full-width'); // Apply the class that spans 3 columns
        contentBlock.classList.remove('two-columns', 'one-column'); // Remove other column classes
      } else if (contentBlockColumns == '2') {
        contentBlock.classList.add('two-columns'); // Apply the class that spans 2 columns
        contentBlock.classList.remove('full-width', 'one-column'); // Remove other column classes
      } else {
        contentBlock.classList.add('one-column'); // Apply the class that spans 1 column
        contentBlock.classList.remove('full-width', 'two-columns'); // Remove other column classes
      }

      if (contentBlockRowSpan == '1') {
        contentBlock.classList.add('one-row');
      } else if (contentBlockRowSpan == '2') {
        contentBlock.classList.add('two-rows');
      } else if (contentBlockRowSpan == '3') {
        contentBlock.classList.add('two-rows');
      } else if (contentBlockRowSpan == '4') {
        contentBlock.classList.add('two-tows');
      } else if (contentBlockRowSpan == '5') {
        contentBlock.classList.add('two-rows');
      }

      // Create the HTML structure based on the metafield values
      var contentBlockHTML = '';

      // Now create the inner content block
      contentBlockHTML += '<div class="content-block-inner" style="color:' + textColor + '">';

      if (title) {
        contentBlockHTML += '<h2>' + title + '</h2>';
      }
      if (text) {
        contentBlockHTML += '<p>' + text + '</p>';
      }
      if (buttonText) {
        contentBlockHTML += '<span>' + buttonText + '</span>';
      }

      contentBlockHTML += '</div>'; // Close the content-block-inner

      // Check if image exists, and if so, place it outside of the content-block-inner
      if (image) {
        contentBlockHTML +=
          '<img class="content-block-bg" src="' +
          image +
          '" alt="' +
          (title || 'Content Block Image') +
          '" width="600" height="auto">';
      }

      // Assign the created HTML structure to the content block
      contentBlock.innerHTML = contentBlockHTML;

      // Insert the content block after the specified product
      if (contentBlockPosition <= productItems.length) {
        productItems[contentBlockPosition - 1].after(contentBlock); // Use position from metafield
      } else {
        productItems[productItems.length - 1].after(contentBlock); // Insert at the end if position exceeds product count
      }
    }

    // Reconnect the observer after making changes
    observer.observe(productsContainer, config);
  }

  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  var debouncedInsertContentBlock = debounce(insertContentBlock, 250);

  // Initial insertion attempt
  insertContentBlock();
}
